import { createElement, } from 'react';
import { Grid, Icon, Input } from '@alifd/next';
import DictSelect from './dictSelect';
import _, { isEmpty, isUndefined } from 'lodash';
import { mapping } from './jsonSchema';
const { Row, Col } = Grid;
const SchemaArray = (props) => {
    const { prefix, data, showEdit, model, open, index: indexProps } = props;
    const { items } = data;
    const prefixArray = [].concat(prefix, 'items');
    const { fields = [items] } = data;
    const isDict = !isEmpty(items.dict);
    const tagPaddingLeftStyle = () => {
        const { length } = props.prefix.filter((name) => name != 'properties');
        return {
            paddingLeft: `${20 * (length + 1)}px`,
        };
    };
    const getPrefix = () => {
        return [].concat(props.prefix, 'items');
    };
    const handleClickIcon = (index) => {
        const prefix = getPrefix();
        const keyArr = [].concat(prefix, 'properties');
        props.model.setOpenValueAction(keyArr);
    };
    const showIcon = (index) => {
        const prefixArray = [].concat(prefix, 'items');
        const prefixArrayStr = [].concat(prefixArray, 'properties').join('.');
        return _.get(open, prefixArrayStr);
    };
    const changeValueDict = (value, index) => {
        const prefix = getPrefix();
        const key = [].concat(prefix, 'dictType');
        props.model.changeValueAction(key, value);
    };
    const handleChangeValue = (value) => {
        const prefix = getPrefix();
        const key = [].concat(prefix);
        props.model.changeValueAction(key, value);
    };
    const handleDeleteArrayField = (index) => {
        const key = [].concat(prefix, 'fields');
        props.model.deleteArrayItems(key, index);
    };
    if (!isUndefined(fields)) {
        return fields.map((items, index) => {
            return (createElement("div", { className: "array-type", key: index },
                createElement(Row, { className: "array-item-type", justify: "space-around" },
                    createElement(Col, { span: 12, className: "col-item name-item col-item-name", style: tagPaddingLeftStyle() },
                        createElement(Row, { justify: "space-around" },
                            createElement(Col, { span: 2, className: "down-style-col" }, items.type === 'object' ? (createElement("span", { className: "down-style", onClick: () => handleClickIcon(index) }, showIcon(index) ? createElement(Icon, { type: "arrow-down", size: 'small' }) : createElement(Icon, { type: "arrow-up", size: 'small' }))) : null),
                            createElement(Col, { span: 22 },
                                createElement(Input, { disabled: true, value: `${_.last(prefix)}[${index}] ` })))),
                    createElement(Col, { span: 10, className: "col-item col-item-desc" }, isDict ? (createElement(DictSelect, { onChange: (value) => changeValueDict(value, index), initialValues: items.dict, placeholder: '请选择', value: items.dictType })) : (createElement(Input, { value: items.description, onChange: (value) => handleChangeValue(value), disabled: true }))),
                    createElement(Col, { span: 2, className: "col-item col-item-setting" }, index !== 0 && (createElement("span", { onClick: () => handleDeleteArrayField(index) },
                        createElement(Icon, { type: "minus", size: 'small' }))))),
                createElement("div", { className: "option-formStyle" }, mapping(prefixArray, items, showEdit, model, open, index))));
        });
    }
    return null;
};
export default SchemaArray;
